export const PRODUCT_DELETE_RESET = 'PRODUCT_DELETE_RESET'
export const PRODUCT_DELETE_SET_ERROR = 'PRODUCT_DELETE_SET_ERROR'
export const PRODUCT_DELETE_SET_DELETED = 'PRODUCT_DELETE_SET_DELETED'
export const PRODUCT_DELETE_TOGGLE_LOADING = 'PRODUCT_DELETE_TOGGLE_LOADING'



// WEBPACK FOOTER //
// ./src/store/modules/product/delete/mutation_types.js